import * as TypeGraphQL from "type-graphql";
export var InstitutionalSentimentErrorsScalarFieldEnum;
(function (InstitutionalSentimentErrorsScalarFieldEnum) {
    InstitutionalSentimentErrorsScalarFieldEnum["id"] = "id";
    InstitutionalSentimentErrorsScalarFieldEnum["timestamp"] = "timestamp";
    InstitutionalSentimentErrorsScalarFieldEnum["operation"] = "operation";
    InstitutionalSentimentErrorsScalarFieldEnum["error"] = "error";
    InstitutionalSentimentErrorsScalarFieldEnum["recordCount"] = "recordCount";
    InstitutionalSentimentErrorsScalarFieldEnum["severity"] = "severity";
    InstitutionalSentimentErrorsScalarFieldEnum["createdAt"] = "createdAt";
})(InstitutionalSentimentErrorsScalarFieldEnum || (InstitutionalSentimentErrorsScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(InstitutionalSentimentErrorsScalarFieldEnum, {
    name: "InstitutionalSentimentErrorsScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=InstitutionalSentimentErrorsScalarFieldEnum.js.map